import { makeStyles } from 'vendor/material';

const useStyles = makeStyles(() => ({
  hiddenField: {
    display: 'none',
  },
}));

export default useStyles;
